export default __webpack_public_path__ + "static/media/fAbeNcake.3f3a163c.jpeg";